<style lang="scss">
  @use "@sourcewhale/shared/svelte-design-system/assets/css/design-system/utils";
  @use "@sourcewhale/shared/svelte-design-system/assets/css/design-system/mixins";
  @use "@sourcewhale/shared/svelte-design-system/assets/css/design-system/colors";

  .modal-body {
    display: flex;
    flex-direction: column;
    padding: utils.in_rem(16px);
    padding-top: 0;
    gap: utils.in_rem(16px);
    width: 100%;
    > p {
      @include mixins.body2();
      color: colors.get(textLighterBlack);
    }
  }

  .modal-footer {
    display: flex;
    align-items: center;
    justify-content: space-between;
    padding: utils.in_rem(16px);
    border-top: 1px solid colors.get(interfaceSwGrey_4);
    background: white;
    .left {
      display: flex;
      align-items: center;
      gap: utils.in_rem(8px);
    }
    .right {
      display: flex;
      flex-direction: row;
      align-items: center;
      gap: utils.in_rem(8px);
    }
  }
</style>

<script>
  import Button from "@sourcewhale/shared/svelte-design-system/components/atoms/Button.svelte";
  import TextToggle from "@sourcewhale/shared/svelte-design-system/components/atoms/Toggles/TextToggle.svelte";
  import MultiSelectDropdown from "@sourcewhale/shared/svelte-design-system/components/molecules/Dropdown/MultiSelectDropdown/MultiSelectDropdown.svelte";
  import SingleSelectDropdown from "@sourcewhale/shared/svelte-design-system/components/molecules/Dropdown/SingleSelectDropdown/SingleSelectDropdown.svelte";
  import Modal from "@sourcewhale/shared/svelte-design-system/components/molecules/Modal/Modal.svelte";

  export let candidates = [];
  export let campaignId = null;
  export let onclose = () => {};
  export let confirmCallback = async () => {};

  let searchPhones = "missing";
  let searchEmails = "missing";
  let contactTypes = ["personal", "work"];
  let bulkVerify = false;

  const ENRICH_OPTIONS = [
    { label: "Missing only", id: "missing" },
    { label: "All selected", id: "all" },
    { label: "Don't enrich", id: "none" },
  ];

  const EMAIL_TYPES = [
    { label: "Personal", id: "personal" },
    { label: "Work", id: "work" },
  ];

  const onConfirm = async (skipping) => {
    const body = { candidates, campaignId };

    if (!skipping) {
      body.searchPhones = searchPhones;
      body.searchEmails = searchEmails;
      body.contactTypes = contactTypes;
      body.bulkVerify = bulkVerify;
    }

    await confirmCallback(body);
    onclose();
  };
</script>

<Modal size="small" {onclose}>
  <h3 slot="header">Some profiles are missing contact details</h3>
  <div class="modal-body">
    <p>
      Before adding them to Sourcewhale, you can choose to enrich their missing
      emails or phone numbers.
    </p>
    <SingleSelectDropdown
      label="Enrich phone numbers"
      items={ENRICH_OPTIONS}
      bind:selected={searchPhones}
      style="height: 2.25rem; width: 100%;"
    />
    <SingleSelectDropdown
      label="Enrich emails"
      items={ENRICH_OPTIONS}
      bind:selected={searchEmails}
      style="height: 2.25rem; width: 100%;"
    />
    <MultiSelectDropdown
      label="Email type"
      items={EMAIL_TYPES}
      bind:selectedItems={contactTypes}
      showFilter={false}
      showToggleAll={false}
      dropdownStyle="height: 2.25rem; width: 100%;"
    >
      <span slot="display">
        {#if contactTypes.length === 0}
          Select email types
        {:else if contactTypes.length === 1}
          {EMAIL_TYPES.find((x) => x.id === contactTypes[0]).label}
        {:else}
          Personal & work
        {/if}
      </span>
    </MultiSelectDropdown>
    <TextToggle bind:checked={bulkVerify} label="Verify emails" tooltip>
      <span slot="tooltip">
        Emails will be shown in green (high-quality) or amber (risky). Invalid
        emails will be removed.
      </span>
    </TextToggle>
  </div>
  <div class="modal-footer">
    <div class="left">
      <Button kind="tertiary-grey" onclick={onclose}>Cancel</Button>
    </div>
    <div class="right">
      <Button
        kind="tertiary-grey"
        onclick={async () => {
          await onConfirm(true);
        }}>Skip</Button
      >
      <Button
        kind="primary"
        trailingIcon="far fa-arrow-right"
        onclick={async () => {
          await onConfirm(false);
        }}
      >
        {#if searchPhones !== "none" || searchEmails !== "none"}
          Confirm & enrich
        {:else}
          Confirm
        {/if}
      </Button>
    </div>
  </div>
</Modal>
